export default {
  "HitPaw Add Music to Audio Online": "HitPaw ऑनलाइन ऑडियो में म्यूज़िक जोड़ें",
  "Add BGM to Audio without any difficulties.": "बिना किसी मुश्किल के ऑडियो में BGM जोड़ें।",
  "Add New": "नया जोड़ें",
  "Format": "फॉर्मेट",
  "Add tracks": "ट्रैक जोड़ें",

};
